import { ComponentProps, FC } from 'react';
import { Text } from '@connect-x-app/hybrid-ui';
import { SystemMessageLevel } from '@connect-x-app/shared-domain-models';
import { COLORS } from '@connect-x-app/shared-ui';
import { Icon } from '@connect-x-app/web-ui';
import classNames from 'classnames';

import './systemMessage.scss';

type Props = {
  level: SystemMessageLevel | null;
  message: string;
  time: string;
};

export const SystemMessage: FC<Props> = ({ level, message, time }) => {
  return (
    <div className={classNames('system-message-container', level)}>
      <div className="system-message">
        <Icon className="system-message-icon" size={2} {...getIconProps(level)} />
        <Text as="span" className="system-message-text" size="XS" weight="bold">
          {message}
        </Text>
      </div>
      <Text as="span" className="system-message-time" size="XS" weight="semiBold">
        {time}
      </Text>
    </div>
  );
};

const getIconProps = (systemMessageLevel: SystemMessageLevel | null): ComponentProps<typeof Icon> => {
  switch (systemMessageLevel) {
    case SystemMessageLevel.ATTENTION:
      return { colorName: COLORS.zulu.$10, name: 'exclamationDiamondOutline' };
    case SystemMessageLevel.CAUTION:
      return { colorName: COLORS.zulu.$10, name: 'exclamationTriangleOutline' };
    case SystemMessageLevel.WARNING:
      return { colorName: COLORS.yuma.$01, name: 'exclamationHexagonOutline' };
    case SystemMessageLevel.OK:
      return { colorName: COLORS.zulu.$10, name: 'checkCircleOutline' };
    case SystemMessageLevel.UNCLEAR:
      return { colorName: COLORS.zulu.$10, name: 'exclamationCircleOutline' };
    case SystemMessageLevel.IMPORTED:
    case SystemMessageLevel.ACCENT:
      return { colorName: COLORS.zulu.$10, name: 'circularInfoOutline' };
    case SystemMessageLevel.UNKNOWN:
    default:
      return { colorName: COLORS.yuma.$01, name: 'circularInfoOutline' };
  }
};
